// @flow
import React, { Component } from "react";
import { withRouter, browserHistory } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import { buttonStyles } from "../../global/components/StyledButtons";
import { deleteCookie } from "../../global/functions/cookies";
import { clearState } from "../../global/actions/databaseActions";
import ExitToApp from "@material-ui/icons/ExitToApp";

class LogoffButton extends Component<*> {
  constructor(props) {
    super(props);
  }

  logoff() {
    deleteCookie("access_token", this.props.params.conference);
    this.props.actions.clearState();
    browserHistory.push("/" + this.props.params.conference + "/signup");
  }

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div className="form-text top-margin-15" style={{ marginBottom: "-5%", opacity: "0.7" }}>
        <Button color="primary" variant="raised" type='button' className={classes.shineBtn} onClick={this.logoff.bind(this)}>
          Log Off
          <ExitToApp />
        </Button>
      </div>
    );
  }
};

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ clearState }, dispatch) };
}

export default connect(null, mapDispatchToProps)(withStyles(buttonStyles)(withRouter(LogoffButton)));


// WEBPACK FOOTER //
// ./src/global/components/LogoffButton.js